/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box, Grid } from '@mui/material';
import RadioField
  from 'src/DistributionPackages/BestFit.Magicline/Resources/Private/App/Components/FormFields/RadioField';
import PropTypes from 'prop-types';

/**
 * SubscriptionsTerms Component
 * @param contract
 * @param rateBundle
 * @param oldContractTermPrice
 * @returns {JSX.Element}
 * @constructor
 */
export default function SubscriptionTerms({ contract, rateBundle, oldContractTermPrice }) {
  /**
     *
     * @param term
     * @returns {JSX.Element}
     */
  const renderSubscriptionDuration = (term) => (
    <Grid className="contract-duration" item xs={12}>
      {term.termValue}
      {' '}
      {term.termValue === 1 ? 'Monat' : 'Monate'}
    </Grid>
  );

  /**
     *
     * @param priceParts
     * @returns {JSX.Element}
     */
  const renderPrice = (priceParts) => (
    <>
      <Grid item className="contract-price" xs={6}>
        <Box className="price">{priceParts[0]}</Box>
      </Grid>
      <Grid className="contract-price-additional " item xs={6}>
        <Box>{priceParts[1]}</Box>
        <Box>mtl.</Box>
      </Grid>
    </>
  );

  /**
     *
     * @param priceParts
     * @param oldPriceParts
     * @returns {JSX.Element}
     */
  const renderPriceWithOldPrice = (priceParts, oldPriceParts) => (
    <>
      <Grid item xs={6}>
        <Grid container className="old-price">
          {renderPrice(oldPriceParts)}
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container className="new-price">
          {renderPrice(priceParts)}
        </Grid>
      </Grid>
    </>
  );

  /**
     * Get the subscription terms
     * @returns {*}
     */
  const getSubscriptionTerms = () => rateBundle.terms.map((term) => {
    const priceParts = (term.price).toString().split('.');
    let oldPrice = null;
    if (oldContractTermPrice) {
      const contractTermsWithOldPrice = oldContractTermPrice.split(',')
        .map((termIdAndPrice) => termIdAndPrice.replace(/(\r\n|\n|\r)/gm, '').trim().split(':'));
      contractTermsWithOldPrice.forEach((contractWithOldPrice) => {
        if (term.id.toString() === contractWithOldPrice[0]) {
          oldPrice = contractWithOldPrice[1].split('.');
        }
      });
    }

    const label = (
      <Grid container className="contract-term">
        {' '}
        {renderSubscriptionDuration(term)}
        {' '}
        {oldPrice && oldPrice.length > 0 ? renderPriceWithOldPrice(priceParts, oldPrice) : renderPrice(priceParts)}
      </Grid>
    );

    return {
      label,
      value: term.id,
    };
  });

  return (
    <RadioField
      name={contract.name}
      label={contract.label}
      data={getSubscriptionTerms()}
      defaultValue="bert"
      fullWidth
    />
  );
}

SubscriptionTerms.propTypes = {
  contract: PropTypes.object.isRequired,
  rateBundle: PropTypes.object.isRequired,
  oldContractTermPrice: PropTypes.string,
};

SubscriptionTerms.defaultProps = {
  oldContractTermPrice: null,
};
